import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";

const SelectInput = ({
    className,
    label,
    placeholder = "Select an option",
    options = [],
    name,
    value,
    onChange,
    mandatory,
    error = "",
    border
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const handleSelect = (selectedValue) => {
        onChange({ target: { name, value: selectedValue } });
        setIsOpen(false);
    };

    return (
        <div ref={containerRef} className="mb-[8px] relative">
            {label && (
                <label className="block mb-2 text-gray-700 font-medium text-[14px]">
                    {label}{" "}
                    <sup className="text-red-500 text-sm">{mandatory ? "*" : ""}</sup>
                </label>
            )}

            <div
                className={`${className} ${border ? "border" : "shadow"} rounded-lg py-3 px-3 flex justify-between items-center cursor-pointer bg-white`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className={`${value ? "text-black" : "text-gray-400"} text-sm`}>
                    {options.find((o) => o.value === value)?.label || `Select ${placeholder}`}
                </span>
                <FaChevronDown />
            </div>

            {isOpen && (
                <div className="absolute z-10 w-full bg-white border border-gray-400 rounded-lg max-h-60 overflow-auto shadow-lg">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            onClick={() => handleSelect(option.value)}
                            className="px-4 py-2 hover:bg-gradient-to-r from-[#ECF1FF] to-[#EED8FF] cursor-pointer text-sm"
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}

            {error && (
                <div className="w-full bg-red-100 rounded-md h-auto mt-1">
                    <p className="text-red-500 text-sm ml-3">{error}</p>
                </div>
            )}
        </div>
    );
};

export default SelectInput;
